import { useLoginStore, LoginState } from '../LoginStore';
import LoginPopup from '../LoginPopup';
import LoginButton from '../LoginButton';
import { Profile } from '../../Profile';
import { AnalyticsGTM } from '../../../../services/analytics-gtm';

import { useInitialTokenRefresh } from './hooks';
import useStyles from './styles';
import { DropdownOpenDirection } from './types';

type LoginAreaProps = {
  dropdownOpenDirection?: DropdownOpenDirection;
  loginButtonFullWidth?: boolean;
  showName?: boolean;
  analytics: AnalyticsGTM;
  loginButtonClassName?: string;
};

export default function LoginArea({
  dropdownOpenDirection = DropdownOpenDirection.DOWN,
  loginButtonFullWidth,
  showName,
  analytics,
  loginButtonClassName,
}: LoginAreaProps) {
  const styles = useStyles();
  const popupVisible = useLoginStore((state) => state.popupVisible);
  const loginState = useLoginStore((state) => state.loginState);

  useInitialTokenRefresh();

  if (loginState === LoginState.Pending) {
    return null;
  }

  const isLoggedIn = LoginState.In === loginState;

  return (
    <div className={styles.root}>
      {isLoggedIn ? (
        <Profile
          analytics={analytics}
          showName={showName}
          dropdownOpenDirection={dropdownOpenDirection}
        />
      ) : (
        <LoginButton
          analytics={analytics}
          isFullWidth={loginButtonFullWidth}
          className={loginButtonClassName}
        />
      )}
      {popupVisible && <LoginPopup analytics={analytics} />}
    </div>
  );
}
